import { WelcomeMessageScope } from '@api'
import { z } from 'zod'

import {
  FollowUpRequestBodySchema,
  FollowUpSchema,
} from '@/modules/message/components/follow-ups/types.ts'
import {
  MessageSchema,
  MessageSequenceSchema,
} from '@/modules/message/service/message-service'

/** Settigs reactivator/toggle */
export interface SettingsReactivator {
  state: boolean
}

/** Settigs reactivator/toggle fan max number*/
export interface SettingsFanMaxNumber {
  max: number
}

export interface ColorVariant {
  id: number
  colorHex: string
  backgroundColorHex: string | null
}

export interface ScriptCategory {
  id: number
  name: string
  orderNumber: number
}

export const WelcomeMessageSchema = z.object({
  id: z.number(),
  sequence: MessageSequenceSchema,
  timeframeEnd: z.string(),
  timeframeStart: z.string(),
  includedTrackedLinks: z.array(z.string()),
  excludedTrackedLinks: z.array(z.string()),
  scope: z.nativeEnum(WelcomeMessageScope),
  sequenceId: z.number(),
  statistics: z.object({
    totalPPVBought: z.number(),
    totalReads: z.number(),
    totalSent: z.number(),
    totalResponses: z.number(),
  }),
  followUpEnabled: z.boolean(),
  followUpDto: FollowUpSchema.optional(),
})

// ------------------------- UI Types and Schemas -----------------
export const TimeObjectSchema = z.object({
  hour: z.number(),
  minute: z.number(),
  second: z.number(),
  nano: z.number(),
})

export const WelcomeMessageFormSchema = z.object({
  id: z.number().optional(),
  messages: MessageSchema.array(),
  timeframeEnd: TimeObjectSchema.optional().nullable(),
  timeframeStart: TimeObjectSchema.optional().nullable(),
  includedTrackedLinks: z.array(z.string()),
  excludedTrackedLinks: z.array(z.string()),
  followUpEnabled: z.boolean(),
  followUpDto: FollowUpRequestBodySchema.nullable().optional(),
})

export type WelcomeMessageRequestBody = z.infer<typeof WelcomeMessageFormSchema>

export type WelcomeMessage = z.infer<typeof WelcomeMessageSchema>

export interface WelcomeSettings {
  minutes: number
  state: boolean
}
